// extracted by mini-css-extract-plugin
export default {"language":"Language_language__-0IpI"};